import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { Role } from '@enums/role.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { BillingComponent } from './pages/billing/billing.component';

const routes: Routes = [
  {
    path: MenuItemPath.get(MenuItem.billing),
    component: BillingComponent,
    canActivate: [AuthGuard],
    data: {
      role: [
        Role.administrator,
        Role.manager
      ]
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class BillingRoutingModule { }
